module.exports = __webpack_public_path__ + "assets/document-link.31c4bcdb.svg";